import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../cn.js';
import { Spinner } from './Spinner.js';
const VARIANTS = {
    // The primary action carries a warm shadow in its own colour, which is what
    // makes it read as raised rather than as a coloured rectangle.
    primary: 'bg-primary text-on-primary shadow-brand hover:bg-primary-dark hover:shadow-raised active:translate-y-px active:shadow-card',
    secondary: 'bg-navy text-on-primary hover:bg-navy-secondary active:translate-y-px',
    outline: 'border border-border-strong bg-background text-content hover:border-primary-300 hover:bg-primary-50 active:translate-y-px',
    ghost: 'bg-transparent text-content-secondary hover:bg-surface hover:text-content',
    danger: 'bg-danger text-white hover:brightness-95 active:translate-y-px',
};
// Heights follow the control tokens; md is the 48px default touch target.
const SIZES = {
    sm: 'h-9 px-3.5 text-sm gap-1.5',
    md: 'h-12 px-5 text-base gap-2',
    lg: 'h-14 px-7 text-[1.0625rem] gap-2.5',
};
/**
 * The class list behind `Button`, exported so a link can be styled as a button
 * without nesting an anchor inside a `<button>` (which is invalid markup).
 */
export function buttonClassName({ variant = 'primary', size = 'md', fullWidth = false, className, } = {}) {
    return cn('inline-flex items-center justify-center rounded-full font-semibold', 'transition-[background-color,box-shadow,transform,border-color] duration-150 ease-out select-none', 'disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none disabled:active:translate-y-0', VARIANTS[variant], SIZES[size], fullWidth && 'w-full', className);
}
export const Button = forwardRef(function Button({ variant = 'primary', size = 'md', loading = false, fullWidth = false, leadingIcon, trailingIcon, className, disabled, type = 'button', children, ...rest }, ref) {
    const isDisabled = disabled || loading;
    return (_jsxs("button", { ref: ref, type: type, disabled: isDisabled, "aria-busy": loading || undefined, className: buttonClassName({ variant, size, fullWidth, className }), ...rest, children: [loading ? _jsx(Spinner, { size: "sm" }) : leadingIcon, children, !loading && trailingIcon] }));
});
//# sourceMappingURL=Button.js.map